import DateFormat from '../../shared/helpers/date-format'
let { full, shortMonth, longMonth, dayOfMonth, year } = DateFormat

const DateRangeFormatter = {
  toFullString(range) {
    if (range.isSingleDay()) {
      return full(range.date)
    }

    if (range.start.year < range.end.year) {
      return DateRangeFormatter.toYearRange(range)
    }

    if (range.start.month < range.end.month) {
      return `Week of ${DateRangeFormatter.toMonthRange(range)}`
    }

    return `Week of ${DateRangeFormatter.toDayRange(range)}`
  },

  toShortString(range) {
    if (range.isSingleDay()) {
      return `${DateRangeFormatter.toMonthDay(range.start)}, ${year(
        range.start
      )}`
    }

    if (range.start.year < range.end.year) {
      return DateRangeFormatter.toYearRange(range)
    }

    if (range.start.month < range.end.month) {
      return DateRangeFormatter.toMonthRange(range)
    }

    return DateRangeFormatter.toDayRange(range)
  },

  toMonthRange(range) {
    return `${DateRangeFormatter.toMonthDay(range.start)}–${DateRangeFormatter.toMonthDay(range.end)}, ${year(range.end)}` // prettier-ignore
  },

  toYearRange(range) {
    return `${DateRangeFormatter.toMonthDay(range.start)}, ${year(range.start)}–${DateRangeFormatter.toMonthDay(range.end)}, ${year(range.end)}` // prettier-ignore
  },

  toDayRange(range) {
    return `${DateRangeFormatter.toMonthDay(range.start)}–${dayOfMonth(range.end)}, ${year(range.end)}` // prettier-ignore
  },

  toMonthDay(date) {
    return `${DateRangeFormatter.toShortMonth(date)} ${dayOfMonth(date)}`
  },

  toShortMonth(date) {
    let short = `${shortMonth(date)}.`
    let long = longMonth(date)

    // Months should be abbreviated with a period. Check length + 1 to cover
    // cases such as June, where Jun. is the same length
    return long.length <= short.length ? long : short
  }
}

export default DateRangeFormatter
